import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>Page not Found .. 404</h1>
        </div>
    );
};

export default NotFound;